<!--
Surround component for Announcement. Does not have X to dismiss as with Notice.
The idea is it's there on the homepage til you do what you have to do :-)

Usage: <Reminder category="category" />
@author cm359n
-->
<template>
  <div :class="title == '' ? 'cwDiv-hide' : 'cwDiv'">
    <div class="cwContainer">
      <h1 class="cwHeader">{{ title }}</h1>
      <div class="cwContent">
        <Announcement :category="props.category"
          :getTitle="true"
          @gotTitle="t => { setTitle(t) }" />
      </div>
      <div class="reminder-action-container" v-if="link">
        <button class="reminder-action" @click="go(link.path)">{{ link.name }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Announcement from '@/components/Announcement.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const props = defineProps({
    category: String,
    link: Object
  })

  const title = ref('')
//  const assessmentDataAvailable = ref(false)
//  const showAssessmentAndFeedback = ref(false)

  function go(link) {
    router.push(link)
  }

  function setTitle (foo) {
    title.value = foo
  }


</script>

<style scoped>

.cwDiv-hide {
    display: none;
}
.reminder-action-container {
    text-align: center;
    padding: 5px;
}
.reminder-action {
    border:0px;
    padding: 4px 14px 4px 14px;
    border-radius:5px;
    background-color: #003865;
    color:white;
    font-weight:700;
}
.cwDiv {
  background: rgba(0, 56, 101, 0.2);
  border-radius: 8px;
  margin-left:5%;
  margin-right:5%;
  margin-bottom:12px;
  padding-bottom:2px;
  margin-top: 2px;
  display: flex;
  justify-content: space-between;
}

.cwHeader {
  margin-left:24px;
  font-family: PTSans;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color:#003865;
  text-align:left;
  padding-top:12px;
  margin-bottom:6px;
}

.cwContent {
  padding-left:24px;
  padding-right:10px;
}

.dismissContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 6px;
  padding-right: 6px;
}

#dismiss {
  width: 21px;
  height: 21px;
  cursor: pointer;
  color: #003865
}

</style>
